import { Flex, FlexProps, Text } from "@mantine/core";

interface IProps extends FlexProps {
  title: string;
  content?: string;
  contentUppercase?: boolean;
}

const BoxShop = ({
  title,
  content,
  contentUppercase = false,
  ...props
}: IProps) => {
  return (
    <Flex direction="column" justify="center" {...props}>
      <Text
        ff="Barlow"
        fz={{ base: 14 }}
        lh={{ base: "155%" }}
        c="basic.4"
        style={{ whiteSpace: "nowrap" }}
      >
        {title}
      </Text>
      <Text
        ff="Barlow"
        fw={{ base: 600 }}
        fz={{ base: 14 }}
        lh={{ base: "155%" }}
        c="basic.5"
        tt={contentUppercase ? "uppercase" : "none"}
      >
        {content}
      </Text>
    </Flex>
  );
};

export default BoxShop;
